export default "__VITE_ASSET__e7961b73__"